/* Bathistoxastos — πρόταση πακέτου και εμπιστοσύνη μέσα στο cart drawer (Dawn).
   Δεν αλλάζει το snippet του drawer: φέρνει το section bx-cart-upsell και το βάζει στο footer. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var loading = false;
  var queued = false;

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function inject() {
    var drawer = drawerEl();
    if (!drawer) return;
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer) return;
    if (loading) { queued = true; return; }
    loading = true;
    fetch(root + '?sections=bx-cart-upsell', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['bx-cart-upsell'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var node = tmp.querySelector('.bx-cup');
        var f = drawerEl() && drawerEl().querySelector('.drawer__footer');
        if (!node || !f) return;
        var old = f.querySelector('.bx-cup');
        if (old) old.remove();
        f.insertBefore(node, f.firstChild);
      })
      .catch(function () {})
      .then(function () {
        loading = false;
        if (queued) { queued = false; inject(); }
      });
  }

  /* Αλλαγή σε πακέτο: βγάζει τους οδηγούς που καλύπτει και βάζει το πακέτο */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bx-upgrade]');
    if (!btn) return;
    var drawer = drawerEl();
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    btn.disabled = true;
    var updates = {};
    (btn.getAttribute('data-remove') || '').split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-add')), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'cart error');
        drawer.renderContents(data);
      })
      .catch(function () { window.location.href = root + 'cart'; });
  });

  function watch() {
    var inner = document.getElementById('CartDrawer');
    var drawer = drawerEl();
    if (!inner || !drawer) return;
    var timer = null;
    function schedule() { clearTimeout(timer); timer = setTimeout(inject, 80); }
    function isCup(n) { return n && n.nodeType === 1 && n.classList.contains('bx-cup'); }
    /* Το Dawn ξαναγράφει μέρη του #CartDrawer σε κάθε αλλαγή καλαθιού */
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.target.closest && m.target.closest('.bx-cup')) continue;
        var added = Array.prototype.slice.call(m.addedNodes);
        var removed = Array.prototype.slice.call(m.removedNodes);
        if (added.length && added.every(isCup)) continue;
        if (removed.length && removed.every(isCup) && !added.length) continue;
        schedule();
        return;
      }
    }).observe(inner, { childList: true, subtree: true });
    /* Όταν ανοίγει το drawer */
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) schedule();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
      }
    } catch (err) {}
    inject();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
